import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import { analyticsConfig } from 'syf-js-utilities/helpers/triggerAnalyticsEvent'

export const triggerOnCloseAnalytics = () => {
  analyticsConfig.defaults.PageKind = 'multiaccount'
  triggerAnalyticsEvent({
    PageFunction: 'dashboard',
    PageKind: 'multiaccount'
  })
}
